const SET_EXTENSIONS = (state, extensions) => {
  state.extensions = extensions
}

const SET_GROUPS = (state, groups) => {
  state.groups = groups
}

const SET_LOCATIONS = (state, locations) => {
  state.locations = locations
}

const SET_MAILBOXES = (state, mailboxes) => {
  state.mailboxes = mailboxes
}

const SET_MENUS = (state, menus) => {
  state.menus = menus
}

const SET_NUMBERS = (state, numbers) => {
  state.numbers = numbers
}

const SET_DEVICES = (state, devices) => {
  state.devices = devices
}

const SET_RECORDINGS = (state, recordings) => {
  state.recordings = recordings
}

const SET_ROUTING_PROFILES = (state, routingProfiles) => {
  state.routingProfiles = routingProfiles
}

const SET_SCHEDULES = (state, schedules) => {
  state.schedules = schedules
}

const SET_USERS = (state, users) => {
  state.users = users
}

export default {
  SET_EXTENSIONS,
  SET_GROUPS,
  SET_LOCATIONS,
  SET_MAILBOXES,
  SET_MENUS,
  SET_NUMBERS,
  SET_DEVICES,
  SET_RECORDINGS,
  SET_ROUTING_PROFILES,
  SET_SCHEDULES,
  SET_USERS,
}
